import api from './baseApi';

export interface TikTokInvalidSession {
    shop: string;
    shopName: string;
}

export const getTikTokInvalidSessions = async (): Promise<TikTokInvalidSession[]> => {
    const response = await api.get<TikTokInvalidSession[]>('tiktok/shops/invalid_sessions');
    return response.data;
};

/** TikTok Shop authorization url that reconnects `shop`; the Shopify app keeps the state until the callback. */
export const getTikTokReconnectUrl = async (shop: string): Promise<string> => {
    const response = await api.get<{ url: string }>('tiktok/authorizeUrl', { params: { shop } });
    return response.data.url;
};
